// section active detection
import "./sectionActiveDetection";
// marquee (universal)
import "./marquee";
// count down animation
import "./tweenValue";
// alert component
import "./alertBox";
// advertise
import "./advertise"
// template scripts
import "./applyAPI";
// i18n scripts
// import "./applyi18n";
// i18n scripts
import "./gameList";